<div class="row bloccodati">
  <div labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Tipo richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.tipoRichiedente ? 'Interno' : 'Esterno'"></div>
  <div *ngIf="ctxBodyFascicolo.fascicolo.tipoRichiedente" labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.richiedenteInterno?.nome"></div>
  <div *ngIf="!ctxBodyFascicolo.fascicolo.tipoRichiedente" labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.richiedenteEsterno"></div>
  <div labelTextInput class="col-sm-3" [typeLabel]="'date'"
       [labelInput]="'Data emissione'" [valueInput]="ctxBodyFascicolo.fascicolo.dataEmissione"></div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label for="quesito_richiesta" class="col-sm-12">Quesito/richiesta</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.richiesta }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label for="sintesi_parere" class="col-sm-12">Sintesi parere</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.sintesiParere }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
